
export const name = "crm-settings-task-reminders";
export const version = "dev";
